// extracted by mini-css-extract-plugin
module.exports = {"link":"Announcements_link__ygQC_","imageContainer":"Announcements_imageContainer__ImGLf","image":"Announcements_image__tfH__"};